import type { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import { getColorWithAlpha } from '@elfsight/widget-utils';

interface EmptyMessageProps extends PropsWithChildren {
  color?: string;
}

export function EmptyMessage({
  color = 'rgb(0, 0, 0)',
  children
}: EmptyMessageProps) {
  return <Container $color={color}>{children}</Container>;
}

const Container = styled.div<{ $color: string }>`
  width: 100%;
  padding: 16px;
  text-align: center;
  border-radius: 4px;
  font:
    400 14px / 18px system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    Helvetica,
    Arial,
    sans-serif,
    'Apple Color Emoji',
    'Segoe UI Emoji',
    'Segoe UI Symbol';
  ${({ $color }) => css`
    background: ${getColorWithAlpha($color, 0.03)};
    color: ${$color};
  `};
`;
